import React from 'react';
import styled from 'styled-components';
import InfoIcon from '../../../svgs/InfoIcon';
import { StyledHtmlRenderer } from '../shared/StyledHtmlRenderer';


const InsertedHtmlRenderer = styled(StyledHtmlRenderer)`
  p {
    margin: 0;
    margin-top: ${p => p.theme.unit(2)};
    margin-bottom: ${p => p.theme.unit(2)};
  }
`;

const ShopDescriptionsDiv = styled.div`
  color: ${p => p.theme.c.text.primary};
  padding-left: ${p => p.theme.unit(6.5)};
  padding-top: ${p => p.theme.unit(8)};
`;

const ShopNameH1 = styled.h1`
  ${({ theme }) => theme.typographyRebrand.heading['4xl']}
  margin: 0;
  text-transform: uppercase;
  color: ${p => p.theme.c.text.primary};
  padding-bottom: ${p => p.theme.unit(4)};
`;

const AboutSectionTitleH2 = styled.h2`
  ${({ theme }) => theme.typographyRebrand.heading.lg}
  color: ${({ theme }) => theme.c.text.primary};
  margin: 0;
`;

const AboutSectionContentDiv = styled(InsertedHtmlRenderer)`
  padding-bottom: ${p => p.theme.unit(2)};
  ${({ theme }) => theme.typographyRebrand.body.sm}
`;

const ImportantTitleContainerDiv = styled.div`
  background-color: ${({ theme }) => theme.c.bg['feature-2']};
  padding: ${({ theme }) => theme.unit(0.5)} ${({ theme }) => theme.unit(1)};
  width: fit-content;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.unit(0.5)};
`;

const ImportantInformationTitleDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading.xs}
  color: ${p => p.theme.c.text.primary};
`;

const IconContainerDiv = styled.div`
  height: ${({ theme }) => theme.unit(2)};
  width: ${({ theme }) => theme.unit(2)};

  color: ${({ theme }) => theme.c.icon.primary};
`;

const ImportantInformationContentDiv = styled(InsertedHtmlRenderer)`
  ${({ theme }) => theme.typographyRebrand.body.sm}
  color: ${p => p.theme.c.text.primary};
`;

/**  Mobile Styles **/
const MobileShopDescriptionsDiv = styled(ShopDescriptionsDiv)`
  padding-top: ${p => p.theme.unit(4)};
  padding-left: 0;
`;

const MobileImportantTitleContainerDiv = styled(ImportantTitleContainerDiv)`
  min-width: ${p => p.theme.unit(36)};
  width: 100%;
  max-height: ${p => p.theme.unit(8)};
  height: auto;
  align-items: flex-start;
  padding: ${p => p.theme.unit(1)};
  box-sizing: border-box;
`;

const MobileIconContainerDiv = styled(IconContainerDiv)``;

const MobileImportantInformationTitleDiv = styled(ImportantInformationTitleDiv)`
  padding-top: 0;
`;

const MobileShopNameH1 = styled(ShopNameH1)``;

const MobileAboutSectionTitleH2 = styled.h2`
  margin: 0;
`;

const ShopDescriptions = (props) => {
  const {
    name = '',
    aboutSectionTitle = '',
    largeDescription = '',
    importantInformationSectionTitle = '',
    importantInformation = '',
    isMobile = false,
  } = props;

  const largeDescriptionRender = (
    <AboutSectionContentDiv dangerouslySetInnerHTML={{
      __html: largeDescription,
    }} />
  );

  const importantInformationRender = (
    <ImportantInformationContentDiv dangerouslySetInnerHTML={{
      __html: importantInformation,
    }} />
  );

  const DesktopBody = (
    <ShopDescriptionsDiv>
      {/* Shop title*/}
      <ShopNameH1> {name} </ShopNameH1>

      {/* About section */}
      <AboutSectionTitleH2>
        {aboutSectionTitle}
      </AboutSectionTitleH2>

      {largeDescriptionRender}

      {/* Important section*/}
      {importantInformation ? (
        <div>
          <ImportantTitleContainerDiv>
            <IconContainerDiv>
              <InfoIcon />
            </IconContainerDiv>

            <ImportantInformationTitleDiv>
              {importantInformationSectionTitle}
            </ImportantInformationTitleDiv>
          </ImportantTitleContainerDiv>

          {importantInformationRender}
        </div>
      ) : null}

    </ShopDescriptionsDiv>
  );

  const MobileBody = (
    <MobileShopDescriptionsDiv>
      {/* Shop title*/}
      <MobileShopNameH1> {name} </MobileShopNameH1>

      {/* About section */}
      <MobileAboutSectionTitleH2>
        {aboutSectionTitle}
      </MobileAboutSectionTitleH2>

      {largeDescriptionRender}

      {/* Important section*/}
      {importantInformation ? (
        <div>
          <MobileImportantTitleContainerDiv>
            <MobileIconContainerDiv>
              <InfoIcon />
            </MobileIconContainerDiv>

            <MobileImportantInformationTitleDiv>
              {importantInformationSectionTitle}
            </MobileImportantInformationTitleDiv>
          </MobileImportantTitleContainerDiv>
          {importantInformationRender}
        </div>
      ) : null}

    </MobileShopDescriptionsDiv>
  );

  const compToRender = isMobile ? MobileBody : DesktopBody;
  return compToRender;
};

export default ShopDescriptions;
